import React, { useEffect } from 'react'

// Components
import LegacyBrowserNotification from './LegacyBrowserNotification'
import DrawNavBar from './DrawNavBar'

// Hooks
import useAuthContext from '../../hooks/useAuthContext'
import useMergedState from '../../hooks/useMergedState'

// Utils
import utils from '../../utils/utils'

function NavigationBar (props) {
  const authContext = useAuthContext()
  const [state, setState] = useMergedState({
    logged: utils.isLogged(),
    mounted: false,
    usrData: utils.getUserInfo(),
    userLoyalty: utils.getUserLoyalty(),
    showNote: true,
  })

  useEffect(() => {
    setState({
      mounted: true,
      logged: props.logged,
      isSupported: utils.supportEs6(),
      userBalance: props.userBalance,
      usrData: props.userData
    })
  }, [])

  const closeNote = () => {
    setState({ showNote: false })
  }

  const logout = () => {
    authContext.logout()
  }

  if (!state.mounted) {
    return (
      <div className='flex-container justify align'>
        <i className='ion-load-a loading' />
      </div>
    )
  }

  return (
    <>
      <DrawNavBar
        userData={props.userData}
        userLoyalty={state.userLoyalty}
        userBalance={props.userBalance}
        logged={props.isLogged}
        logout={logout}
        updateUserInfo={props.updateUserInfo}
        updateUserBalance={props.updateUserBalance}
      />
      <LegacyBrowserNotification
        isSupported={state.isSupported}
        closeNote={closeNote}
        showNote={state.showNote}
      />
    </>
  )
}

export default NavigationBar
